import { render } from "./StrategyView.vue?vue&type=template&id=9a4ad6cc"
import script from "./StrategyView.vue?vue&type=script&lang=js"
export * from "./StrategyView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__